/*!
 *
 * TruckxiSCM
 *
 * Version: 0.0.2
 * Author: @geno_diaz
 * E-mail: GenoCDiaz@gmail.com
 *
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Link, hashHistory, browserHistory, IndexRoute } from 'react-router';

import initTranslation from './components/Common/localize';
import initLoadCss from './components/Common/load-css';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';

import { loadTranslations, setLocale, syncTranslationWithStore, i18nReducer } from 'react-redux-i18n';

import Base from './components/Layout/Base';
import BasePage from './components/Layout/BasePage';
import BaseHorizontal from './components/Layout/BaseHorizontal';

import Users from './containers/Users/users';
import UserForm from './containers/Users/userForm';
import Products from './containers/Products/products';
import ProductForm from './containers/Products/productForm';
import Groups from './containers/Products/groups';
import Categories from './containers/Products/categories';
import Customers from './containers/Customers/customers';
import CustomerForm from './containers/Customers/customerForm';
import Vendors from './containers/Vendors/vendors';
import VendorDetailForm from './containers/Vendors/vendorDetailForm';
import Agents from './containers/Agents/agents';
import AgentForm from './containers/Agents/agentForm';
import PriceLevel from './containers/Products/priceLevel';
import PaymentTerms from './containers/PaymentTerms/paymentTerms';

import GeneralDashboard from './containers/General/generalDashboardRevision';
import CategoryAnalysis from './containers/General/CategoryAnalysis';
import PresidentDashboard from './containers/Purchase/presidentDashboard';
import PurchaseDashboard from './containers/Purchase/purchaseDashboard';
import PurchaseManagerDashboard from './containers/Purchase/purchaseManagerDashboard';
import WarehouseDashboard from './containers/Purchase/warehouseDashboard';
import SalesDashboard from './containers/Sales/salesDashboard';
import PurchaseQuoteList from './containers/Purchase/purchaseQuoteList';
import PurchaseTemplateList from './containers/Purchase/purchaseTemplateList';
import PurchaseScheduleList from './containers/Purchase/purchaseScheduleList';
import PurchaseReturnList from './containers/Purchase/purchaseReturnList';
import PurchaseOrderList from './containers/Purchase/purchaseOrderList';
import PurchaseQuoteForm from './containers/Purchase/purchaseQuoteForm';
import PurchaseScheduleForm from './containers/Purchase/purchaseScheduleForm';
import PurchaseTemplateForm from './containers/Purchase/purchaseTemplateForm';
import PurchaseOrderForm from './containers/Purchase/purchaseOrderForm';
import PurchaseReturnForm from './containers/Purchase/purchaseReturnForm';
import PurchasingPerformance from './containers/Purchase/purchasingPerformance';
import PriceAdjustmentReport from './containers/Purchase/priceAdjustment';
import PriceAdjustmentDetail from './containers/Purchase/priceAdjustmentDetail';
import PurchasePaymentList from './containers/Purchase/purchasePaymentList';
import PurchasePaymentDetail from './containers/Purchase/purchasePaymentDetail';
import PurchasePivotChartDetail from './containers/Purchase/purchasePivotChartDetail';
import PurchasePivotChart from './containers/Purchase/purchasePivotChart';
import PurchaseReferenceReport from './containers/Purchase/purchaseReference';

import Inventories from './containers/Inventories/inventories';
import InventoryDetail from './containers/Inventories/inventoryDetail';
import InventoryLowStock from './containers/Inventories/inventoryLowStock';
import InventoryExpired from './containers/Inventories/inventoryExpired';
import InventoryAdjustments from './containers/Inventories/inventoryAdjustments';
import InventoryAdjustmentForm from './containers/Inventories/inventoryAdjustmentForm';
import InventoryRelocations from './containers/Inventories/inventoryRelocations';
import InventoryRelocationForm from './containers/Inventories/inventoryRelocationForm';
import InventoryRelocationFromInbound from './containers/Inventories/inventoryRelocationFromInbound';
import InventoryRepackages from './containers/Inventories/inventoryRepackages';
import InventoryRepackageForm from './containers/Inventories/inventoryRepackageForm';
import InventoryConverts from './containers/Inventories/inventoryConverts';
import InventoryConvertForm from './containers/Inventories/inventoryConvertForm';
import ScrapRecords from './containers/Inventories/scrapRecords';
import ScrapRecordForm from './containers/Inventories/scrapRecordForm';
import PutAway from './containers/Inventories/putAway';
import PutAwayForm from './containers/Inventories/putAwayForm';
import InboundForm from './containers/Inventories/inboundForm';
import ReceiveList from './containers/Inventories/receiveList';
import ReceiveForm from './containers/Inventories/receiveForm';
import ReceiveHistoryList from './containers/Inventories/receiveHistoryList';
import ReceiveHistoryDetail from './containers/Inventories/receiveHistoryDetail';

import Warehouses from './containers/Inventories/warehouses';
import WarehouseForm from './containers/Inventories/warehouseForm';
import WarehouseDetail from './containers/Inventories/warehouseDetail';
import ZoneForm from './containers/Inventories/zoneForm';
import ZoneDetail from './containers/Inventories/zoneDetail';
import BinForm from './containers/Inventories/binForm';
import BinDetail from './containers/Inventories/binDetail';
import ProductConvertReport from './containers/Inventories/productConvert';
import ProductConvertDetail from './containers/Inventories/productConvertDetail';

import SalesOrders from './containers/Sales/salesOrders';
import PosOrders from './containers/Sales/posOrders';
import PosCredits from './containers/Sales/posCredits';
import PosHolds from './containers/Sales/posHolds';
import SalesOrderForm from './containers/Sales/salesOrderForm';
import Wholesale from './containers/Sales/wholesale';
import WholesaleOrderForm from './containers/Sales/wholesaleOrderForm';
import FavoriteList from './containers/Sales/favoriteList';
import GroupList from './containers/Sales/groupList';
import SalesInvoice from './containers/Sales/salesInvoice';
import EditSalesInvoice from './containers/Sales/editSalesInvoice';
import ViewPosOrder from './containers/Sales/viewPosOrder';
import PromotionsPage from './containers/Sales/PromotionsPage';
import PosReport from './containers/Sales/posReport';
import SalesPerformanceReport from './containers/Sales/salesPerformance';
import ShipToOrders from './containers/Sales/salesOrders';
import PreOrders from './containers/Sales/preOrders';
import ShipFromOrders from './containers/Sales/salesOrders';
import OtherService from './containers/Sales/salesOrders';

import Shipping from './containers/Dispatch/shipping';
import Routing from './containers/Dispatch/routing';
import EditRoutes from './containers/Dispatch/editRoutes';
import Drivers from './containers/Dispatch/Drivers';
import AutoRouting from './containers/Dispatch/AutoRouting';

import ARList from './containers/AR/ARList';
import ARDetail from './containers/AR/ARDetail';
import CreateAR from './containers/AR/createAR';
import EditAR from './containers/AR/editAR';
import APList from './containers/AP/APList';
import APDetail from './containers/AP/APDetail';
import CreateAP from './containers/AP/createAP';
import EditAP from './containers/AP/editAP';
import SIPaymentList from './containers/AR/SIPaymentList';
import SIPaymentForm from './containers/AR/SIPaymentForm';
import GeneralReport from './containers/AR/generalReport';
import MobileCustomerStatement from './containers/AR/mobileCustomerStatement';
import CustomerStatement from './containers/AR/customerStatement';
import CustomerStatementMain from './containers/AR/customerStatementMain';
import VendorStatement from './containers/AP/vendorStatement';
import VendorStatementMain from './containers/AP/vendorStatementMain';
import CityReport from './containers/AR/cityReport';

import UserManagement from './containers/Settings/userManagement';
import UserManagementDetail from './containers/Settings/userManagementDetail';
import GroupManagement from './containers/Settings/groupManagement';
import GroupManagementDetail from './containers/Settings/groupManagementDetail';
import TaxManagement from './containers/Settings/taxManagement';
import CurrencyManagement from './containers/Settings/currencyManagement';
import AgentManagement from './components/Agents/AgentManagement';
import { PriceAdjustment, ProductConvert, PurchasePivot, PurchaseReference,
  PurchasePerformance, SalesPerformance, POSPicture } from './components/Report/report';
import ActionLog from './containers/Settings/ActionLog';

import CustomerReturn from './containers/Returns/customerReturn';
import CustomerReturnForm from './containers/Returns/customerReturnForm';
import CustomerIssueCredit from './containers/Returns/customerIssueCredit';
import RestockReturnForm from './containers/Returns/restockReturnForm';
import CreditForm from './containers/Returns/creditForm';
import InventoryReturn from './containers/Returns/inventoryReturn';

import MobileManagement from './containers/General/MobileManagement';
import AdjustmentInventory from "./containers/Inventories/adjustmentInventory";
import rmaForm from "./containers/RMA/rmaForm";
import customerRMA from "./containers/RMA/rma";
import dispatchRMA from "./containers/RMA/rma";

import Login from './containers/Auth/login';
import Signup from './containers/Auth/signup';
import RequireAuth from './containers/Auth/require_auth'
import UserBasedAuthentication from './containers/Auth/userBased_auth';
import reducers, { rootEpic } from './reducers';
import { createEpicMiddleware } from 'redux-observable';
import reduxThunk from 'redux-thunk';
// import createLogger from 'redux-logger';

import { checkStatues } from './actions/auth_actions';
import { AUTH_USER } from './actions/type';


// Import Translation files
import chMessages from '../i18n/ch.json';
import enMessages from '../i18n/en.json';

import MMdriver from './containers/MMdriver';

// Init translation system
initTranslation();
// Init css loader (for themes)
initLoadCss();

const epicMiddleware = createEpicMiddleware(rootEpic);

const configureStore = (state, middleware) => {
  const response = createStore(reducers, state, middleware);

  return response;
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const middlewares = [reduxThunk, createLogger({ collapsed: true })];
const middlewares = [reduxThunk, epicMiddleware];
const middleware = composeEnhancers(applyMiddleware(...middlewares));

// const middlewares = [thunk, router, ReduxPromise];

const store = configureStore({}, middleware);
// const createStoreWithMiddleware = applyMiddleware(middleware)();
// const store = createStoreWithMiddleware(reducers);

var translationsObject = {}
translationsObject.en = enMessages;
translationsObject.ch = chMessages;
syncTranslationWithStore(store);
store.dispatch(loadTranslations(translationsObject));
store.dispatch(setLocale('en'));

// Check
const token = localStorage.getItem('token');
const user = localStorage.getItem('userType');
// if (token) {
//     store.dispatch(checkStatues());
// }

const Root = React.createClass({
    // Refresh function, not suggested to be used, may cause some issue.

    childContextTypes: {
        refresh: React.PropTypes.func
    },

    getChildContext() {
        return {
            refresh: () => this.forceUpdate()
        };
    },

    render() {
        return (
            <Provider store={store}>
                <Router
                  history={browserHistory}
                >

                    <Route path="/" component={RequireAuth(Base)}>

                        {/* Default route*/}
                        <IndexRoute component={RequireAuth(GeneralDashboard)} />


                        <Route path="dashboard" component={RequireAuth(GeneralDashboard)} />
                        <Route path="generaldashboard" component={RequireAuth(GeneralDashboard)} />
                        <Route path="purchaseManagerDashboard" component={RequireAuth(PurchaseManagerDashboard)} />
                        <Route path="presidentDashboard" component={RequireAuth(PresidentDashboard)} />
                        <Route path="categoryAnalysis" component={RequireAuth(CategoryAnalysis)} />

                        <Route path="warehouse" component={RequireAuth(WarehouseDashboard)} />
                        <Route path="sales" component={RequireAuth(SalesDashboard)} />

                        <Route path="users" component={RequireAuth(Users)} />
                        <Route path="users/new" component={RequireAuth(UserForm)} />
                        <Route path="users/:id" component={RequireAuth(UserForm)} />
                        <Route path="customers" component={RequireAuth(Customers)} />
                        <Route path="customers/new" component={RequireAuth(CustomerForm)} />
                        <Route path="customers/:id" component={RequireAuth(CustomerForm)} />
                        <Route path="products" component={RequireAuth(Products)} />
                        <Route path="products/new" component={RequireAuth(ProductForm)} />
                        <Route path="products/groups" component={RequireAuth(Groups)} />
                        <Route path="products/categories" component={RequireAuth(Categories)} />
                        <Route path="products/:id" component={RequireAuth(ProductForm)} />
                        <Route path="vendors" component={RequireAuth(Vendors)} />
                        <Route path="vendors/new" component={RequireAuth(VendorDetailForm)} />
                        <Route path="vendors/:id" component={RequireAuth(VendorDetailForm)} />
                        <Route path="agents" component={RequireAuth(Agents)} />
                        <Route path="agents/new" component={RequireAuth(AgentForm)} />
                        <Route path="agents/:id" component={RequireAuth(AgentForm)} />
                        <Route path="priceLevel" component={RequireAuth(PriceLevel)} />
                        <Route path="paymentTerms" component={RequireAuth(PaymentTerms)} />

                        <Route path="purchase" component={RequireAuth(PurchaseDashboard)} />
                        <Route path="purchaseQuote" component={RequireAuth(PurchaseQuoteList)} />
                        <Route path="purchaseQuote/new" component={RequireAuth(PurchaseOrderForm)} />
                        <Route path="purchaseQuote/:id" component={RequireAuth(PurchaseOrderForm)} />
                        <Route path="purchaseTemplate" component={RequireAuth(PurchaseTemplateList)} />
                        <Route path="purchaseTemplate/new" component={RequireAuth(PurchaseOrderForm)} />
                        <Route path="purchaseTemplate/:id" component={RequireAuth(PurchaseOrderForm)} />
                        <Route path="purchaseSchedule" component={RequireAuth(PurchaseScheduleList)} />
                        <Route path="purchaseSchedule/new" component={RequireAuth(PurchaseScheduleForm)} />
                        <Route path="purchaseSchedule/:id" component={RequireAuth(PurchaseScheduleForm)} />
                        <Route path="purchaseReturn" component={RequireAuth(PurchaseReturnList)} />
                        <Route path="purchaseReturn/new" component={RequireAuth(PurchaseReturnForm)} />
                        <Route path="purchaseReturn/newCredit" component={RequireAuth(PurchaseReturnForm)} />
                        <Route path="purchaseReturn/:id" component={RequireAuth(PurchaseReturnForm)} />
                        <Route path="purchaseOrder" component={RequireAuth(PurchaseOrderList)} />
                        <Route path="purchaseOrder/new" component={RequireAuth(PurchaseOrderForm)} />
                        <Route path="purchaseOrder/:id" component={RequireAuth(PurchaseOrderForm)} />
                        <Route path="purchasingPerformanceReport" component={RequireAuth(PurchasingPerformance)} />
                        <Route path="priceAdjustmentReport" component={RequireAuth(PriceAdjustmentReport)} />
                        <Route path="priceAdjustmentDetail" component={RequireAuth(PriceAdjustmentDetail)} />
                        <Route path="purchasePayment" component={RequireAuth(PurchasePaymentList)} />
                        <Route path="purchasePayment/:id" component={RequireAuth(PurchasePaymentDetail)} />
                        <Route path="purchasePivotChart" component={RequireAuth(PurchasePivotChart)} />
                        <Route path="purchasePivotChart/:id" component={RequireAuth(PurchasePivotChartDetail)} />
                        <Route path="purchasePivotChart/new" component={RequireAuth(PurchasePivotChartDetail)} />
                        <Route path="purchaseReferenceReport" component={RequireAuth(PurchaseReferenceReport)} />


                        <Route path="salesOrders" component={RequireAuth(SalesOrders)} />
                        <Route path="salesOrders/new" component={RequireAuth(SalesOrderForm)} />
                        <Route path="salesOrders/:id" component={RequireAuth(SalesOrderForm)} />
                        <Route path="outboundOrders" component={RequireAuth(SalesOrders)} />
                        <Route path="outboundOrders/new" component={RequireAuth(SalesOrderForm)} />
                        <Route path="outboundOrders/:id" component={RequireAuth(SalesOrderForm)} />
                        <Route path="mobileSalesOrders" component={RequireAuth(SalesOrders)} />
                        <Route path="mobileSalesOrders/new" component={RequireAuth(SalesOrderForm)} />
                        <Route path="mobileSalesOrders/:id" component={RequireAuth(SalesOrderForm)} />
                        <Route path="wholesale" component={RequireAuth(Wholesale)} />
                        <Route path="wholesale/new" component={RequireAuth(WholesaleOrderForm)} />
                        <Route path="favoriteList" component={RequireAuth(FavoriteList)} />
                        <Route path="groupList" component={RequireAuth(GroupList)} />
                        <Route path="promotions" component={RequireAuth(PromotionsPage)} />
                        <Route path="salesInvoice" component={RequireAuth(SalesInvoice)} />
                        <Route path="salesInvoice/:id" component={RequireAuth(EditSalesInvoice)} />
                        <Route path="shipToOrders" component={RequireAuth(ShipToOrders)} />
                        <Route path="preOrders" component={RequireAuth(PreOrders)} />
                        <Route path="shipFromOrders" component={RequireAuth(ShipFromOrders)} />
                        <Route path="otherService" component={RequireAuth(OtherService)} />
                        {/* <Route path="pos" component={RequireAuth(Pos)} /> */}
                        <Route path="pos" component={POSPicture} />
                        <Route path="posReport" component={RequireAuth(PosReport)} />
                        <Route path="posOrders" component={RequireAuth(PosOrders)} />
                        <Route path="posOrders/:id" component={RequireAuth(ViewPosOrder)} />
                        <Route path="posCredits" component={RequireAuth(PosCredits)} />
                        <Route path="SalesPerformanceReport" component={RequireAuth(SalesPerformanceReport)} />
                        <Route path="posHolds" component={RequireAuth(PosHolds)} />


                        <Route path="inventories" component={RequireAuth(Inventories)} />
                        <Route path="inventories/detail" component={RequireAuth(InventoryDetail)} />
                        <Route path="inventories/detail/:id" component={RequireAuth(InventoryDetail)} />
                        <Route path="inventories/lowStock" component={RequireAuth(InventoryLowStock)} />
                        <Route path="inventories/expired" component={RequireAuth(InventoryExpired)} />
                        <Route path="inventories/repackage" component={RequireAuth(InventoryRepackages)} />
                        <Route path="inventories/repackage/new" component={RequireAuth(InventoryRepackageForm)} />
                        <Route path="inventories/repackage/:id" component={RequireAuth(InventoryRepackageForm)} />
                        <Route path="inventories/convert" component={RequireAuth(InventoryConverts)} />
                        <Route path="inventories/convert/new" component={RequireAuth(InventoryConvertForm)} />
                        <Route path="inventories/convert/:id" component={RequireAuth(InventoryConvertForm)} />
                        <Route path="inventories/receive" component={RequireAuth(ReceiveList)} />
                        <Route path="inventories/receive/:id" component={RequireAuth(ReceiveForm)} />
                        <Route path="inventories/receive/new" component={RequireAuth(ReceiveForm)} />
                        <Route path="inventories/receiveHistory" component={RequireAuth(ReceiveHistoryList)} />
                        <Route path="inventories/receiveHistory/:id" component={RequireAuth(ReceiveHistoryDetail)} />
                        <Route path="inventories/relocation" component={RequireAuth(InventoryRelocations)} />
                        <Route path="inventories/relocation/new" component={RequireAuth(InventoryRelocationForm)} />
                        <Route path="inventories/relocation/:id" component={RequireAuth(InventoryRelocationForm)} />
                        <Route path="inventories/relocation/inbound" component={RequireAuth(InventoryRelocationFromInbound)} />
                        <Route path="inventories/adjustment" component={RequireAuth(InventoryAdjustments)} />
                        <Route path="inventories/adjustment/new" component={RequireAuth(InventoryAdjustmentForm)} />
                        <Route path="inventories/adjustment/:id" component={RequireAuth(InventoryAdjustmentForm)} />

                        <Route path="scrapRecords" component={RequireAuth(ScrapRecords)} />
                        <Route path="scrapRecords/new" component={RequireAuth(ScrapRecordForm)} />
                        <Route path="scrapRecords/:id" component={RequireAuth(ScrapRecordForm)} />
                        <Route path="putAway" component={RequireAuth(PutAway)} />
                        <Route path="putAway/new" component={RequireAuth(PutAwayForm)} />
                        <Route path="putAway/inbound" component={RequireAuth(InboundForm)} />
                        <Route path="putAway/:id" component={RequireAuth(PutAwayForm)} />
                        <Route path="warehouses" component={RequireAuth(Warehouses)} />
                        <Route path="warehouses/form" component={RequireAuth(WarehouseForm)} />
                        <Route path="warehouses/detail" component={RequireAuth(WarehouseDetail)} />
                        <Route path="zoneForm" component={RequireAuth(ZoneForm)} />
                        <Route path="zoneDetail" component={RequireAuth(ZoneDetail)} />
                        <Route path="binForm" component={RequireAuth(BinForm)} />
                        <Route path="binDetail" component={RequireAuth(BinDetail)} />
                        <Route path="productConvertReport" component={RequireAuth(ProductConvertReport)} />
                        <Route path="productConvertReport/new" component={RequireAuth(ProductConvertDetail)} />
                        <Route path="adjustmentInventory" component={AdjustmentInventory}/>

                        <Route path="mobileManagement" component={RequireAuth(MobileManagement)} />

                        <Route path="rmaForm" component={RequireAuth(rmaForm)} />
                        <Route path="customerRMA" component={RequireAuth(customerRMA)} />
                        <Route path="customerRMA/new" component={RequireAuth(rmaForm)} />
                        <Route path="dispatchRMA" component={RequireAuth(dispatchRMA)} />
                        <Route path="dispatchRMA/:id" component={RequireAuth(rmaForm)} />
                        <Route path="customerRMA/:id" component={RequireAuth(rmaForm)} />

                        <Route path="shipping" component={RequireAuth(Shipping)} />
                        <Route path="routing" component={RequireAuth(Routing)} />
                        <Route path="autorouting" component={RequireAuth(AutoRouting)} />
                        <Route path="editRoutes" component={RequireAuth(EditRoutes)} />
                        <Route path="drivers" component={RequireAuth(Drivers)} />

                        <Route path="customerReturn" component={RequireAuth(CustomerReturn)} />
                        <Route path="customerReturn/new" component={RequireAuth(CustomerReturnForm)} />
                        <Route path="customerReturn/:id" component={RequireAuth(CustomerReturnForm)} />
                        <Route path="customerIssueCredit" component={RequireAuth(CustomerIssueCredit)} />
                        <Route path="restockReturn/:id" component={RequireAuth(RestockReturnForm)} />
                        <Route path="customerCredit/new" component={RequireAuth(CreditForm)} />
                        <Route path="customerCredit/:id" component={RequireAuth(CreditForm)} />
                        <Route path="inventoryReturn" component={RequireAuth(InventoryReturn)} />
                        <Route path="AR" component={RequireAuth(ARList)} />
                        <Route path="AR/new" component={RequireAuth(CreateAR)} />
                        <Route path="AR/:id" component={RequireAuth(EditAR)} />
                        <Route path="AP" component={RequireAuth(APList)} />
                        <Route path="AP/new" component={RequireAuth(CreateAP)} />
                        <Route path="AP/:id" component={RequireAuth(EditAP)} />
                        <Route path="arSalesInvoice" component={RequireAuth(SalesInvoice)} />
                        <Route path='salesInvoicePayment' component={RequireAuth(SIPaymentList)} />
                        <Route path='salesInvoicePayment/:id' component={RequireAuth(SIPaymentForm)} />
                        <Route path="generalReport" component={RequireAuth(GeneralReport)} />
                        <Route path="customerStatement" component={RequireAuth(CustomerStatement)} />
                        <Route path="customerStatementMain" component={RequireAuth(CustomerStatementMain)} />
                        <Route path="vendorStatement" component={RequireAuth(VendorStatement)} />
                        <Route path="vendorStatementMain" component={RequireAuth(VendorStatementMain)} />
                        <Route path='mobileCustomerStatement' component={RequireAuth(MobileCustomerStatement)} />
                        <Route path='cityReport' component={RequireAuth(CityReport)} />

                        <Route path="userManagement" component={RequireAuth(UserManagement)} />
                        <Route path="userManagement/:id" component={RequireAuth(UserManagementDetail)} />
                        <Route path="userManagement/new" component={RequireAuth(UserManagementDetail)} />
                        <Route path="groupManagement" component={RequireAuth(GroupManagement)} />
                        <Route path="groupManagement/new" component={RequireAuth(GroupManagementDetail)} />
                        <Route path="groupManagement/:id" component={RequireAuth(GroupManagementDetail)} />
                        <Route path="taxManagement" component={RequireAuth(TaxManagement)} />
                        <Route path="currencyManagement" component={RequireAuth(CurrencyManagement)} />
                        <Route path="agentManagement" component={RequireAuth(AgentManagement)} />
                        <Route path="actionLog" component={RequireAuth(ActionLog)} />

                        <Route path="priceAdjustment" component={PriceAdjustment} />
                        <Route path="productConvert" component={ProductConvert} />
                        <Route path="purchasePivot" component={PurchasePivot} />
                        <Route path="purchaseReference" component={PurchaseReference} />
                        <Route path="purchasePerformance" component={PurchasePerformance} />
                        <Route path="salesPerformance" component={SalesPerformance} />

                        <Route path="mmdriver" component={MMdriver} />
                    </Route>

                    <Route path="/login" component={Login} />
                    <Route path="/signup" component={Signup} />

                    {/* Not found handler */}
                    {/*<Route path="*" component={NotFound}/>*/}

                </Router>
            </Provider>
        );
    }
});

ReactDOM.render(<Root />,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./master/jsx/App.jsx